import React, { useState, useEffect } from "react";
import IntroScreen from "./pages/IntroScreen";
import Assessment from "./pages/Assessment";

function App() {
  useEffect(() => {
    const domain = window.location.hostname;
    const theme = domain.includes("betterworks.asia") ? "bwa" : "default";
    document.documentElement.setAttribute("data-theme", theme);
  }, []);

  const [language, setLanguage] = useState<"en" | "vn">("en");
  const [started, setStarted] = useState(false);

  return (
    <>
      {!started ? (
        <IntroScreen
          language={language}
          setLanguage={setLanguage}
          onStart={() => setStarted(true)}
        />
      ) : (
        <Assessment language={language} />
      )}
    </>
  );
}


export default App;
